import React from "react";
import MatterDetails from "./MatterDetails";
import MobileMatterView from "./MobileMatterView";
import useIsMobile from "../../hooks/useIsMobile";

/**
 * Route-level fork for `/matter/:id/*` (Mobile DMS v1, Phase 4).
 *
 * Desktop keeps the full `MatterDetails` workspace (folder tree,
 * Apryse, AI rail). Phones get `MobileMatterView` — a flat document
 * list + lightweight viewer — and never mount the Apryse WASM
 * bootstrap at all.
 */
const ResponsiveMatterDetails = () => {
  const isMobile = useIsMobile();
  return isMobile ? <MobileMatterView /> : <MatterDetails />;
};

export default ResponsiveMatterDetails;
